export class ProspectMobileWrapper {
  prospectId: number;
  mobilePhone: string;
}
